import React, { useState } from 'react'
import {
  CModal,
  CButton,
  CModalHeader,
  CModalBody,
  CFormInput,
  CForm,
  CModalFooter,
  CDatePicker,
} from '@coreui/react-pro'
import { recalculateBalanceEvent } from './model'
import { changedDateFormatfinsystem } from '../../../libs/utils'

type Props = {
  isOpen: boolean
  onClose: () => void
}

const getMinDate = () => {
  const currentDate = new Date()

  return new Date(currentDate.getFullYear(), currentDate.getMonth() - 2, 1)
}

const getMaxDate = () => {
  const currentDate = new Date()

  return new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
  )
}

export const RecalcModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const [currency, setCurrency] = useState('')
  const [walletId, setWalletId] = useState('')
  const [dateTime, setDateTime] = useState<{
    dateFrom: Date | null
    dateTo: Date | null
  }>({
    dateFrom: null,
    dateTo: null,
  })

  const handleDateChange = (
    date: Date | null,
    field: 'dateFrom' | 'dateTo',
  ) => {
    setDateTime((prev) => ({
      ...prev,
      [field]: date,
    }))
  }

  const handleSubmit = () => {
    if (!currency || !dateTime.dateFrom || !dateTime.dateTo) {
      alert('Please fill in all fields')
      return
    }

    recalculateBalanceEvent({
      walletId: walletId,
      currency: currency,
      dateFrom: `${changedDateFormatfinsystem(dateTime.dateFrom)}`,
      dateTo: `${changedDateFormatfinsystem(dateTime.dateTo)}`,
    })

    onClose()
  }

  return (
    <CModal visible={isOpen} onClose={onClose}>
      <CModalHeader style={{ borderBottom: 'none' }}>
        <h4 className="text-center mb-4">Recalculate wallet balance</h4>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CFormInput
            className="mb-2"
            id="walletId"
            label="walletId"
            value={walletId}
            onChange={(e) => setWalletId(e.target.value)}
          />
          <CFormInput
            className="mb-2"
            id="currency"
            label="Currency"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          />
          <CDatePicker
            minDate={getMinDate()}
            maxDate={getMaxDate()}
            className="mb-2"
            id="dateFrom"
            label="From date"
            onDateChange={(date) => handleDateChange(date, 'dateFrom')}
          />
          <CDatePicker
            minDate={getMinDate()}
            maxDate={getMaxDate()}
            className="mb-2"
            id="dateTo"
            label="To date"
            onDateChange={(date) => handleDateChange(date, 'dateTo')}
          />
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton className="w-100" onClick={handleSubmit}>
          Start calculate
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
